export default "__VITE_ASSET__n3nJsQVw__"